import Components from "../../components";
import settings from "./settings";

const Cart = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.Cart
        id="cart"
        label="Cart"
        data={data}
        dataSetter={dataSetter}
        settings={settings}
      />
    </div>
  );
};

export default Cart;
